import React, { Component } from 'react'
import Webcam from 'react-webcam'
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import {storage} from './Firebase'
import { onAuthStateChanged, signOut } from "firebase/auth";
import { firebaseAuth, firestore } from './Firebase'
import { doc, updateDoc } from "firebase/firestore"; 
import { useNavigate } from 'react-router-dom';

export default class FaceRegister extends Component {
  constructor(props){
    super(props);
    this.imageref={}
    this.state = {
      image: null,
      User : '',
    }
  }
  photoCapture =() =>{
    this.setState({
      image: this.imageref.current.getScreenshot()
    })
  }
  resetCapture =() =>{
    this.setState({
      image:null
    })
  }
  GetURL = async (e) => {
    e.preventDefault();
    let user = this.state.User
    const pathReference = await getDownloadURL(ref(storage, `UserRegisteredImages/${user}`));
    // console.log(pathReference)
    const path = pathReference
    // console.log(path)
    return path
  }

  UploadURL = async (e)=>{
    e.preventDefault();
    const path = await this.GetURL(e);
    // console.log(path)
    await updateDoc(doc(firestore, 'Users', this.state.User), {
      UserProfileImage : path
    });
    console.log('Url Uploaded')
    this.signOutUser();
    this.props.navigate('/Login')
  }

  OnRegister = async (e)=>{
    e.preventDefault();
    await this.getUser(e);
    const imageURL = this.state.image.split(',')[1]
    const byteCharacters = atob(imageURL);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    let imageU = new Blob([byteArray], { type: 'image/jpeg' });
    let user = this.state.User
    const storageRef = ref(storage, `UserRegisteredImages/${user}`);
    const metaData = {
      contentType: 'image/jpeg',
    };
    uploadBytes(storageRef, imageU, metaData).then((snapshot) => {
      this.UploadURL(e);
      console.log('Image Uploaded!');
      // console.log(snapshot)
    });
  }

  getUser = async(e)=>{
    e.preventDefault();
    await onAuthStateChanged(firebaseAuth, (user) => {
      if (user) {
        const number = user.phoneNumber;
        this.setState({
          User : number
        })
      } else {
        console.log('No User')
      }
    });
  }

  signOutUser = ()=>{
    signOut(firebaseAuth).then(() => {
      console.log('Sign-out successful - Registration succesfull')
    }).catch((error) => {
      console.log(error)
    });
  }

  render() {
    return (
    <>
    <div className='FRS'>
      <div className='Camera'>
        {this.state.image ? 
          <img src={this.state.image} alt='click'></img>
          :<Webcam audio={false} 
          ref={this.imageref}
          screenshotFormat='image/jpeg'/>}
      </div>
      <div className='Cbuttons'>
        <div className='Cbutton1-1'>
            <button type='submit' onClick={(e)=>this.OnRegister(e)}>REGISTER</button>
        </div>
        <div className='Cbutton2'>
            <button type='submit' onClick={() => this.photoCapture() }>CAPTURE</button>
        </div>
        <div className='Cbutton3'>
            <button type='submit' onClick={() => this.resetCapture() }>RECAPTURE</button>
        </div>
      </div>
    </div>
    </>
    )
  }
}
export function FaceRegisterH (props){
  const navigate = useNavigate()
  return(<FaceRegister navigate={navigate}/>)
}